"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _Caption = _interopRequireDefault(require("./Caption"));

var Select = function Select(props) {
  var value = props.value,
      name = props.name,
      onChange = props.onChange,
      children = props.children,
      label = props.label,
      rest = (0, _objectWithoutProperties2.default)(props, ["value", "name", "onChange", "children", "label"]);
  return /*#__PURE__*/_react.default.createElement(_antd.Space, {
    direction: "vertical",
    size: 6
  }, label && /*#__PURE__*/_react.default.createElement(_Caption.default, {
    children: label
  }), /*#__PURE__*/_react.default.createElement(_antd.Select, (0, _extends2.default)({
    value: value,
    onChange: onChange,
    name: name,
    children: children
  }, rest)));
};

var _default = Select;
exports.default = _default;